import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import { INTERNATIONAL_PAYMENT_URL } from 'lib/constants/routes';

const InternationalPayeesContainer = () => {
    const translate = useTranslate('internationalPayment');

    const handleProceed = () => {
        (window as any).open(INTERNATIONAL_PAYMENT_URL, '_blank').focus();
    };

    return (
        <PageContainer className="international-payee-container">
            <Typography>{translate('introText')}</Typography>
            <Button className="center" onClick={handleProceed}>
                {translate('proceed')}
            </Button>
        </PageContainer>
    );
};

export default InternationalPayeesContainer;
